import React from 'react';
import { Calendar, MapPin, Bed, Shield, UserCheck } from 'lucide-react';

interface Props {
  application: Record<string, any>;
}

const PFRON_LABELS: Record<string, { label: string; color: string }> = {
  pending: { label: 'Oczekuje', color: 'bg-yellow-100 text-yellow-700' },
  approved: { label: 'Przyznano', color: 'bg-green-100 text-green-700' },
  rejected: { label: 'Odmowa', color: 'bg-red-100 text-red-700' },
};

export const TurnusScheduleWidget: React.FC<Props> = ({ application: app }) => {
  const turnusDate = app.trip_date ? new Date(app.trip_date) : null;
  const now = new Date();
  const daysUntil = turnusDate ? Math.ceil((turnusDate.getTime() - now.getTime()) / (1000 * 60 * 60 * 24)) : null;
  const pfronStatus = app.pfron_decision_number ? 'approved' : app.funding_source === 'pfron' ? 'pending' : null;

  return (
    <div className="bg-gradient-to-br from-rose-50 to-pink-50 rounded-lg shadow p-5 border border-rose-200">
      <h3 className="font-bold text-sm flex items-center gap-2 mb-3 text-rose-800">
        <Calendar size={16} />
        Harmonogram turnusu
        {daysUntil !== null && daysUntil > 0 && (
          <span className="ml-auto text-xs bg-rose-200 text-rose-800 px-2 py-0.5 rounded-full">za {daysUntil} dni</span>
        )}
      </h3>
      <div className="grid grid-cols-2 gap-3 text-sm">
        {turnusDate && (
          <div className="flex items-center gap-2">
            <Calendar size={14} className="text-rose-500 shrink-0" />
            <span>{turnusDate.toLocaleDateString('pl-PL')}</span>
          </div>
        )}
        {app.residence_address && (
          <div className="flex items-center gap-2">
            <MapPin size={14} className="text-rose-500 shrink-0" />
            <span className="truncate">{app.residence_address}</span>
          </div>
        )}
        {app.disability_level && (
          <div className="flex items-center gap-2">
            <Bed size={14} className="text-rose-500 shrink-0" />
            <span>Stopień: {app.disability_level}</span>
          </div>
        )}
        {app.guardian_required && (
          <div className="flex items-center gap-2">
            <UserCheck size={14} className="text-rose-500 shrink-0" />
            <span>Opiekun: {app.guardian_name || 'Wymagany'}</span>
          </div>
        )}
        {pfronStatus && (
          <div className="flex items-center gap-2 col-span-2">
            <Shield size={14} className="text-rose-500 shrink-0" />
            <span className="text-gray-600">PFRON:</span>
            <span className={`px-2 py-0.5 rounded text-xs font-medium ${PFRON_LABELS[pfronStatus]?.color || ''}`}>
              {PFRON_LABELS[pfronStatus]?.label}
            </span>
            {app.pfron_decision_number && <span className="text-xs text-gray-500">({app.pfron_decision_number})</span>}
          </div>
        )}
        {app.funding_source && !pfronStatus && (
          <div className="flex items-center gap-2 col-span-2">
            <Shield size={14} className="text-rose-500 shrink-0" />
            <span>Finansowanie: {app.funding_source}</span>
          </div>
        )}
      </div>
    </div>
  );
};
